"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableDateField = exports.DateField = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactDatePicker = _interopRequireDefault(require("@adsk/alloy-react-date-picker"));
var _DateFieldFooter = require("./DateFieldFooter");
var _dateUtils = require("../../utils/data/dateUtils");
var _EditableFieldWrapper = require("../EditableFieldWrapper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DateField = _ref => {
  let {
    date,
    onChange,
    defaultIsOpen,
    onHide,
    error,
    required = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_alloyReactDatePicker.default, {
    style: {
      width: "100%"
    },
    format: _alloyReactDatePicker.default.VALID_FORMATS.DEFAULT,
    triggerProps: {
      style: {
        width: "100%"
      }
    }
    // we use defaultIsOpen to have interface consistent with the other edit fields,
    // but for the datepicker the prop is called `defaultOpen`
    ,
    defaultOpen: defaultIsOpen,
    date: date ? (0, _dateUtils.getDateStringAsDate)(date) : null,
    onChange: newDate => {
      if (!newDate) {
        // pressing the backspace key will trigger the onChange and with a null value, so
        // we only want to clear the field when it is not required
        if (!required) {
          onChange(null);
        }
      } else {
        // The datepicker returns the date in UTC, which potentially
        // resolves to the prior day when passed back in unless we're careful about it.
        // So in order to avoid timezone issues, and because the server expects it in this format,
        // this component chops off the hours/mins/seconds of a date,
        // and returns it as a YYY-MM-DD string
        onChange((0, _dateUtils.getDateFormatToDays)(newDate));
      }
    },
    onHide: onHide,
    renderFooter: _ref2 => {
      let {
        reset,
        toggleOverlay
      } = _ref2;
      return !date ? null : /*#__PURE__*/_react.default.createElement(_DateFieldFooter.DateFieldFooter, {
        reset: reset,
        toggleOverlay: toggleOverlay,
        disabled: required
      });
    },
    error: error
  });
};
exports.DateField = DateField;
const EditableDateField = _ref3 => {
  let {
    label,
    disabled = false,
    containerRef,
    fieldKey,
    required = false,
    viewOnly = false,
    ...props
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_EditableFieldWrapper.EditableFieldWrapper, {
    fieldKey: fieldKey,
    inlineEditStyle: {
      border: "none"
    },
    label: label,
    value: props.date ? (0, _dateUtils.getDateStringAsDisplayText)(props.date) : undefined,
    disabled: disabled,
    containerRef: containerRef,
    showDisabledReason: !viewOnly,
    renderInput: _ref4 => {
      let {
        value,
        onChange: inlineEditOnChange
      } = _ref4;
      return /*#__PURE__*/_react.default.createElement(DateField, _extends({}, props, {
        onHide: () => inlineEditOnChange(value),
        onChange: date => {
          if (!date) {
            props.onChange(null);
            inlineEditOnChange(undefined);
          } else {
            props.onChange(date);
            inlineEditOnChange(date);
          }
        },
        required: required
      }));
    },
    required: required
  });
};
exports.EditableDateField = EditableDateField;
//# sourceMappingURL=DateField.js.map